import React from "react";
import { Checkbox } from "@mui/material";
import { inlineChoiceControlSx } from "../../common/dashboard/formStyles";

// Monday 13362035864 (Thunder Bay). Update Member Form.dc.html :558-571 and
// :2769-2772 (the same design serves Create Member). The backend accepts only
// these labels and stores them in this order.
export const MEMBER_OWNERSHIP_DIVERSITY_COLUMNS = [
  [
    "Indigenous-owned",
    "Women-owned",
    "Owned by a racialized person or person of colour",
    "2SLGBTQI+-owned",
    "Owned by a person with a disability",
    "Newcomer-owned",
  ],
  [
    "Franchise",
    "Publicly traded company",
    "Non-profit",
    "Institution",
    "Government",
    "Branch office",
  ],
] as const;

const designOrder: readonly string[] = MEMBER_OWNERSHIP_DIVERSITY_COLUMNS.flat();

/** Always a list, so a save that unticks every box sends [] and clears it. */
export const getMemberOwnershipDiversityInput = (selected?: readonly string[] | null): string[] =>
  designOrder.filter((option) => (selected || []).includes(option));

type MemberOwnershipDiversityFieldProps = {
  selected?: readonly string[];
  /** Update Member marks each box that differs from the saved member. */
  baselineSelected?: readonly string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
};

export const MemberOwnershipDiversityField = ({
  selected = [],
  baselineSelected,
  onChange,
  disabled,
}: MemberOwnershipDiversityFieldProps) => (
  <div
    className="flex flex-col gap-[6px]"
    data-testid="member-ownership-diversity"
    role="group"
    aria-labelledby="member-ownership-diversity-label"
    aria-describedby="member-ownership-diversity-helper"
  >
    <p id="member-ownership-diversity-label" className="text-[14px] font-bold leading-[normal] text-[#0A0A0A]">
      Member Ownership Diversity
    </p>
    <p id="member-ownership-diversity-helper" className="text-[13px] leading-[1.5] text-[#0A0A0A]">
      Indicate which apply to the ownership of this member.
    </p>
    {/* Design minmax(280px, 1fr); min() keeps one column inside a card narrower than 280px. */}
    <div className="mt-[4px] grid grid-cols-[repeat(auto-fit,minmax(min(280px,100%),1fr))] items-start gap-x-[20px] gap-y-[12px]">
      {MEMBER_OWNERSHIP_DIVERSITY_COLUMNS.map((column, columnIndex) => (
        <div className="flex min-w-0 flex-col gap-[12px]" key={columnIndex}>
          {column.map((option) => {
            const checked = selected.includes(option);
            const changed = baselineSelected !== undefined && checked !== baselineSelected.includes(option);
            return (
              <label
                className={`flex items-center gap-[9px] ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
                key={option}
              >
                <Checkbox
                  checked={checked}
                  disabled={disabled}
                  onChange={(event) =>
                    onChange(event.target.checked
                      ? getMemberOwnershipDiversityInput([...selected, option])
                      : selected.filter((item) => item !== option))
                  }
                  sx={changed
                    ? { ...inlineChoiceControlSx, outline: "2px solid #E1A731", outlineOffset: -1 }
                    : inlineChoiceControlSx}
                />
                <span className="min-w-0 text-[14px] leading-[normal] text-[#0A0A0A]">{option}</span>
              </label>
            );
          })}
        </div>
      ))}
    </div>
  </div>
);
